import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import TaskProvider, { useTask } from "context/webmaster/task";
import TaskViewProvider, { useTaskView } from "context/webmaster/task_view";
import { useTimeTracking } from "context/time-tracking";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import PlaceholderPage from "components/PlaceholderPage";
import TaskView from "page_components/shared/tasks/TaskView";
import { WebsiteInfoModal } from "page_components/shared/tasks/modals";

import useResponsive from "libs/helpers/useResponsive";

const action_buttons = [
  {
    type: "send_notification",
  },
];

const TaskSingle = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { max } = useResponsive();

  const { updateTask } = useTask();
  const {
    data,
    refetch,
    file_progress,
    sendMessage,
    editMessage,
    loading,
    error,
    task_close_confirmation,
  } = useTaskView();
  const { current, timeTracking } = useTimeTracking();

  const [modalWebsiteInfo, setModalWebsiteInfo] = useState(false);

  const trackingId = useRef(current?.task_id);

  useEffect(() => {
    if (current?.tasks?.[0]?._id) {
      trackingId.current = current.tasks[0]._id;
    } else {
      if (
        trackingId.current !== undefined &&
        data?._id !== undefined &&
        trackingId.current === data._id
      ) {
        refetch();

        trackingId.current = undefined;
      }
    }

    // eslint-disable-next-line
  }, [data, current]);

  useEffect(() => {
    if (error) navigate("/tasks");
  }, [error, navigate]);

  if (error) return null;

  return (
    <DashboardContentLayout
      header={{
        label: data?.title,
        description: {
          value: data?.website,
          onClick: () => setModalWebsiteInfo(true),
        },
        actions: !max.sm && !loading && (
          <p>
            {t("Created at")}{" "}
            <strong>{moment(data?.created_at).format("LL")}</strong>
          </p>
        ),
        async: true,
      }}
      loading={loading}
      actions={action_buttons}
    >
      {!!!task_close_confirmation ? (
        <TaskView
          data={data}
          website={{
            name: data?.website,
            onClick: () => setModalWebsiteInfo(true),
          }}
          loading={loading}
          file_progress={file_progress}
          updateTask={updateTask}
          timeTracking={timeTracking}
          currentTimeTracking={current}
          sendMessage={sendMessage}
          editMessage={editMessage}
        />
      ) : (
        <PlaceholderPage
          title={t("The task has been finished!")}
          text={t(
            "We are glad we could help and would like to thank you for fruitful cooperation :)",
          )}
          button={{
            label: t("Manage your website"),
            href: "/websites",
          }}
        />
      )}

      <WebsiteInfoModal
        id={data?.website_id}
        isOpen={modalWebsiteInfo}
        onClose={() => setModalWebsiteInfo(false)}
      />
    </DashboardContentLayout>
  );
};

const TaskSingleWrapper = () => (
  <TaskProvider>
    <TaskViewProvider>
      <TaskSingle />
    </TaskViewProvider>
  </TaskProvider>
);
export default TaskSingleWrapper;
